// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-index-wrapper-tngee{display:grid;grid-gap:48px}.pages-info-index-wrapper-tngee.pages-info-index-desktop-mhyhe{grid-template-columns:repeat(4,1fr)}.pages-info-index-pageWrapper-rjtdh{padding-bottom:48px}.pages-info-index-pageWrapper-rjtdh.pages-info-index-mobile-cbmuv{padding-top:48px}.pages-info-index-link-buuae{color:#111;display:block;text-decoration:none}.pages-info-index-link-buuae:hover{color:var(--color-primary-hover)}.pages-info-index-title-bjrib{font-size:20px;font-weight:700;text-align:center}.pages-info-index-image-vqwuo{border-radius:6px;height:auto!important;margin-bottom:12px;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-info-index-wrapper-tngee",
	"desktop": "pages-info-index-desktop-mhyhe",
	"pageWrapper": "pages-info-index-pageWrapper-rjtdh",
	"mobile": "pages-info-index-mobile-cbmuv",
	"link": "pages-info-index-link-buuae",
	"title": "pages-info-index-title-bjrib",
	"image": "pages-info-index-image-vqwuo"
};
module.exports = ___CSS_LOADER_EXPORT___;
